// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import React, { useState, useEffect } from 'react';
import { Toggle, IToggleStyles } from 'office-ui-fabric-react';

export interface TogglerType {
    isOn: boolean;
    handleToggle?: (flag: boolean, data?: any) => void;
    data?: any;
    ariaLabel?: string;
    on: string;
    off: string;
}
const activeStyle: Partial<IToggleStyles> = {
    pill: {
        background: '#027c00',
    },
};

const inActiveStyle: Partial<IToggleStyles> = {
    pill: {
        background: '#f00',
    },
};

export default function Toggler(props: any) {

    const [isOn, setIsOn] = useState(props.isOn);
    useEffect(() => {
        setIsOn(props.isOn);
    }, [props.isOn]);

    function onChange(event: React.MouseEvent<HTMLElement>, checked: boolean | undefined) {
        setIsOn(!isOn);
        if (props.handleToggle) {
            props.handleToggle(!isOn, props.data);
        }
    }
    return (
        <Toggle
            onText={props.on}
            offText={props.off}
            ariaLabel={props.ariaLabel}
            role="checkbox"
            checked={isOn}
            styles={isOn ? activeStyle : inActiveStyle}
            onChange={onChange}
        />
    );
}